require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./architecture-sciences-de-la-ville-edar-2-3-4-1.json") })
        }
      }, "path---architecture-sciences-de-la-ville-edar-2-3-4-1");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---architecture-sciences-de-la-ville-edar-2-3-4-1!./.cache/json/architecture-sciences-de-la-ville-edar-2-3-4-1.json
// module id = 330
// module chunks = 231608221292675